"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleGroups = exports.sortElements = void 0;
const usergroups_1 = require("../../../utils/usergroups");
const sortElements = (array, sortBy, order = 'asc', key) => {
    if (typeof array === 'undefined') {
        return undefined;
    }
    return array.sort((x, y) => {
        let xs;
        let ys;
        if (sortBy === 'features') {
            xs = key ? x[key][sortBy][0] : x[sortBy][0];
            ys = key ? y[key][sortBy][0] : y[sortBy][0];
        }
        else {
            xs = key ? x[key][sortBy] : x[sortBy];
            ys = key ? y[key][sortBy] : y[sortBy];
        }
        if (((typeof xs === 'undefined' || xs === null) &&
            typeof ys === 'undefined') ||
            ys === null) {
            return -1;
        }
        if (typeof xs === 'undefined' || xs === null) {
            return order === 'desc' ? 1 : -1;
        }
        if (typeof ys === 'undefined' || ys === null) {
            return order === 'desc' ? -1 : 1;
        }
        const ex = `${xs.toLocaleUpperCase()}`;
        const ey = `${ys.toLocaleUpperCase()}`;
        if (ex < ey)
            return order === 'desc' ? 1 : -1;
        if (ex > ey)
            return order === 'desc' ? -1 : 1;
        return 0;
    });
};
exports.sortElements = sortElements;
const getLocalizedCategory = (groupRow) => (Object.assign(Object.assign({}, groupRow), { group: Object.assign(Object.assign({}, groupRow.group), { name: (0, usergroups_1.getLocalizedGroupType)(groupRow.group.type, groupRow.group.name) }) }));
const groupOrder = [
    'SuperAdminUserGroup',
    'SalesmanUserGroup',
    'CustomerAdminUserGroup',
    'CustomerVisibilityUserGroup',
    'ProjectAdminUserGroup',
    'LightAdminCategoryUserGroup',
    'CategoryUserGroup',
    'NormalUserGroup',
    'CustomerCategoryUserGroup',
    'SokoBidAdminUserGroup',
    'SokoBidCategoryUserGroup',
    'TRMVRUserGroup',
    'WorksiteDiaryUserGroup'
];
function handleGroups(list, orderBy, order) {
    // purpose of this hokale below is just to make it structurally
    // compatible with the absolute mess known as team members
    const { categories, groups } = list.reduce((results, nextRow) => {
        if (nextRow.group.categoryId) {
            return {
                categories: results.categories,
                groups: [...results.groups, nextRow]
            };
        }
        return {
            groups: results.groups,
            categories: [...results.categories, getLocalizedCategory(nextRow)]
        };
    }, { categories: [], groups: [] });
    return categories
        .filter((x) => x.group.type !== 'ParticipantUserGroup')
        .map((category) => ({
        category: Object.assign(Object.assign({}, category.group), { members: (0, exports.sortElements)(category.members, orderBy, order) }),
        groups: groups
            .filter((g) => g.group.categoryId === category.group.id)
            .map((g) => (Object.assign(Object.assign({}, g.group), { members: (0, exports.sortElements)(g.members, orderBy, order) })))
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    }))
        .sort((a, b) => {
        const ia = groupOrder.indexOf(a.category.type);
        const ib = groupOrder.indexOf(b.category.type);
        if (ia !== ib) {
            if (ia > -1 && ib > -1) {
                return ia - ib;
            }
            else if (ia === -1) {
                return 1;
            }
            else if (ib === -1) {
                return -1;
            }
        }
        if (a.category.features &&
            a.category.features.length > 0 &&
            b.category.features &&
            b.category.features.length > 0) {
            if (a.category.features[0] === b.category.features[0]) {
                return a.category.name
                    .toLowerCase()
                    .localeCompare(b.category.name.toLowerCase());
            }
            return a.category.features[0]
                .toLowerCase()
                .localeCompare(b.category.features[0].toLowerCase());
        }
        else {
            return 0;
        }
    });
}
exports.handleGroups = handleGroups;
//# sourceMappingURL=utils.js.map